
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/braze-cohorts",
      function () {
        return require("private-next-pages/destinations/braze-cohorts.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/braze-cohorts"])
      });
    }
  